import * as Yup from "yup"
import AdditionalFieldContent from "./AdditionalFieldContent";

export default class AdditionalField {
    id;

    website;
    module;

    field_key;
    field_type;

    active = true;
    is_required = false;
    has_prefix_choices = false;
    has_suffix_choices = false;

    url_target = '_self';

    constructor() {
        this.url_target = '_self';
        this.contents = new AdditionalFieldContent();
    }

    static schema = (settings) => {
        let fields = {
            field_key: Yup.string().required('CMS.Modules.AdditionalField.Content.Form.field_key').max(40, 'CMS.Modules.AdditionalField.Content.Form.field_key|40|max'),
            field_type: Yup.string().required('CMS.Modules.AdditionalField.Content.Form.field_type'),
            label: Yup.string().required('CMS.Modules.AdditionalField.Content.Form.label').max(100, 'CMS.Modules.AdditionalField.Content.Form.label|100|max'),
            help_text: Yup.string().nullable().max(255, 'CMS.Modules.AdditionalField.Content.Form.help_text|255|max'),
            extra_info_website: Yup.string().nullable().max(255, 'CMS.Modules.AdditionalField.Content.Form.extra_info_website|255|max')
        };

        if (settings.has_prefix_choices) {
            fields.prefix_choices = Yup.string().required('CMS.Modules.AdditionalField.Content.Form.prefix_choices');
        }
        if (settings.has_suffix_choices) {
            fields.suffix_choices = Yup.string().required('CMS.Modules.AdditionalField.Content.Form.suffix_choices');
        }

        if (settings.type === 'url') {
            fields.url_link_text = Yup.string().nullable().required('CMS.Modules.AdditionalField.Content.Form.url_link_text').max(255, 'CMS.Modules.AdditionalField.Content.Form.url_link_text|255|max');
        }


        return Yup.object(fields);
    }

    static fromJson = (json) => {
        let item = new AdditionalField();

        item.id = json.id;

        item.website = json.website;
        item.module = json.module;

        item.field_key = json.field_key;
        item.field_type = json.field_type;
        item.active = json.active === undefined ? true : !!json.active;
        item.is_required = !!json.is_required;
        item.has_prefix_choices = !!json.has_prefix_choices;
        item.has_suffix_choices = !!json.has_suffix_choices;
        item.url_target = json.url_target || '_self';

        item.contents = json.contents.map(content => AdditionalFieldContent.fromJson(content));

        return item;
    }
}
